export enum DatePickerRestriction {
    LowerThanLimit = 0,
    HigherThanLimit = 1
}